import { AppService } from 'src/app/services/app.service';
import { AuthService } from 'src/app/services/auth.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UserModel } from 'src/app/models/user.model';

@Component({
  selector: 'app-footer',
  standalone: false,
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  appUser: UserModel;

  // Variables fetched from local storage
  displayName: string;

  constructor(public appService: AppService,
    private authService: AuthService,
  ) { }

  ngOnInit(): void {
    // Gets the User Name and name
    this.displayName = localStorage.getItem(environment.localStorage.userFirstName) + ' ' + localStorage.getItem(environment.localStorage.userLastName);
  }

  /**
   * Calls the logout service.
   *
   * @returns void
   */
  logout(): void {
    this.authService.logout();
  }
}
